module.exports = __webpack_public_path__ + "static/media/photo10.87d16053.jpg";